import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';

const useGetStateLabel = () => {
    const [setting] = useSettings();
    const stateList = setting[EnumFields.STATE] || [];

    const getStateLabel = (stateCode: string) => {
        const state = stateList.find((item) => item.value === stateCode);
        return state?.label || '';
    };
    return { getStateLabel };
};

export default useGetStateLabel;
